import { JSX } from 'react';
import { ComponentParams, ComponentRendering } from '@sitecore-jss/sitecore-jss-nextjs';
import { BMICalculator } from '@ahc-digital/component-library';
import { useCreateMarketingRenderingHame } from 'src/shared/useCreateMarketingRenderingName';

interface W01BMICalculatorProps {
  rendering: ComponentRendering & { params: ComponentParams };
  params: ComponentParams;
}

export const Default = (props: W01BMICalculatorProps): JSX.Element => {
  const marketingRenderingName = useCreateMarketingRenderingHame(
    props?.rendering?.componentName as string
  );

  return <BMICalculator data-component={marketingRenderingName} />;
};
